/* global Audio */
import { AUDIO_DOWNLOAD_TYPE } from '../../core/local-storage.service';

const AUDIO_TYPES = ['mp3', 'ogg', 'wav', 'wma'];
const AUDIO_CONTENT_TYPES = {
  'mp3': 'audio/mpeg',
  'ogg': 'audio/ogg',
  'wav': 'audio/wav',
  'wma': 'audio/wma',
};

export class AudioService {

  constructor(LocalStorageService) {
    this.localStorage = LocalStorageService;
    this.current = null;
    this.downloadTypes = AUDIO_TYPES;
    this._downloadType = LocalStorageService.getItem(AUDIO_DOWNLOAD_TYPE);
    if (this.downloadTypes.indexOf(this.downloadType) === -1) {
      this.downloadType = this.downloadTypes[0];
    }

    // fires when current audio has been fully downloaded
    this.onLoaded = () => {
      this.loadNextAudio();
    };

    // fires when current audio is ended
    this.onEnded = () => {
      this.playNextAudio();
    };
  }

  createAudio(src) {
    // console.log('create audio', src);
    let audio = new Audio();
    let type = [this.downloadType, ...AUDIO_TYPES]
        .find(key => audio.canPlayType(AUDIO_CONTENT_TYPES[key])) ||
      this.downloadType;
    audio.preload = 'none';
    audio.src = this.getSrcType(src, type);
    return audio;
  }

  play(audio) {
    // console.log('play audio', audio.src);
    if (this.current) {
      if (this.current === audio) {
        if (audio.error) {
        } else if (audio.paused) {
          audio.play();
        } else {
          audio.pause();
        }
        return;
      }
      if (!this.current.error) {
        this.current.pause();
        this.current.currentTime = 0;
      }
    }
    this.current = audio;
    if (audio.error) {
    } else {
      audio.play();
      audio.currentTime = 0;
    }
  }

  set current(audio) {
    if (this._current) {
      this._current.removeEventListener('canplaythrough', this.onLoaded);
      this._current.removeEventListener('ended', this.onEnded);
    }
    this._current = audio;
    if (audio) {
      audio.addEventListener('canplaythrough', this.onLoaded);
      audio.addEventListener('ended', this.onEnded);
    }
  }

  get current() {
    return this._current;
  }

  get downloadType() {
    return this._downloadType;
  }

  set downloadType(value) {
    this.localStorage.setItem(AUDIO_DOWNLOAD_TYPE, value);
    this._downloadType = value;
  }

  getSrcType(src, type) {
    return src + (type === 'wma' ? '' : '?type=' + type);
  }
}



// WEBPACK FOOTER //
// ./src/facts/audio/audio.service.js